import { DELETE_SCENARIO, SAVE_SCENARIO, REFRESH_SCENARIO, START_SCENARIO, SCENARIOS_CHANGED, GET_SCENARIOS } from '../constants/scenario.constants';

export const deleteScenario = scenario => ({ type: DELETE_SCENARIO, scenario });
export const saveScenario = scenario => ({ type: SAVE_SCENARIO, scenario});
export const refreshScenario = scenario => ({ type: REFRESH_SCENARIO, scenario});
export const getScenarios = scenario => ({ type: GET_SCENARIOS, scenario});
export const startScenario = (scenarioId, payload) => ({ type: START_SCENARIO, scenarioId, payload});
export const scenariosChanged = (scenarios) => ({ type: SCENARIOS_CHANGED, scenarios});

